import { partialBind, } from 'remeda';
import { appointmentBookRequestValidate, } from './appointment/AppointmentApi.binding.js';
import { appointmentBook, searchBookableAppointments, } from './appointment/AppointmentApi.js';
import { loginRequestValidate, } from './auth/AuthApi.binding.js';
import { clientInvoiceDownloadInvoice, clientInvoiceDownloadRequestTan, } from './client/invoice/ClientInvoiceApi.js';
import { apiCall, } from './common/apiCall.js';
import { version, } from './common/CommonApi.js';
import { importedTherapistsDelete, importedTherapistsSearch, } from './user/ImportedTherapistsApi.js';
import { searchTherapist, } from './user/UserApi.js';
export { appointmentBookRequestValidate, appointmentBookResponseValidate, appointmentSaveRequestValidate, appointmentSaveResponseValidate, searchBookableAppointmentsRequestValidate, searchBookableAppointmentsResponseValidate, } from './appointment/AppointmentApi.binding.js';
export { appointmentSeriesInterval, appointmentState, isMedicalFeeScheduleLine, } from './appointment/AppointmentApi.js';
export { appointmentTypeLocation, } from './appointment/AppointmentTypeApi.js';
export { loginRequestValidate, loginResponseValidate, } from './auth/AuthApi.binding.js';
export { getClientRequestValidate, getClientResponseValidate, searchClientRequestValidate, searchClientResponseValidate, updateClientRequestValidate, } from './client/ClientApi.binding.js';
export { clientInvoiceDownloadInvoiceRequestValidate, clientInvoiceDownloadInvoiceResponseValidate, clientInvoiceDownloadTanRequestValidate, clientInvoiceDownloadTanResponseValidate, } from './client/invoice/ClientInvoiceApi.binding.js';
export { configRequestValidate, configResponseValidate, versionRequestValidate, versionResponseValidate, } from './common/CommonApi.binding.js';
export { countries, } from './countries.js';
export { createSelfServiceRequestValidate, customerPaymentInfoRequestValidate, customerPaymentInfoResponseValidate, } from './customer/CustomerApi.binding.js';
export { customerUserPatchRequestValidate, customerUserPatchResponseValidate, customerUserPublicSearchRequestValidate, customerUserPublicSearchResponseValidate, customerUserSearchResponseValidate, molliePaymentWebhookRequestValidate, } from './customer/CustomerUserApi.binding.js';
export {} from './customer/CustomerUserApi.js';
export { invoiceSearchResponseValidate, } from './invoice/InvoiceApi.binding.js';
export { invoiceState, } from './invoice/InvoiceApi.js';
export * from './router/legacyPrefixRewrite.js';
export * from './router/localeRewrite.js';
export * from './router/router.js';
export * from './router/translatedRoutesRewrite.js';
export { guessLocale, guessLocaleFromLanguages, isSupportedLocale, localeToLanguages, supportedLocales, translation, } from './translation/translation.js';
export { importedTherapistsDeleteRequestValidate, importedTherapistsSearchRequestValidate, importedTherapistsSearchResponseValidate, } from './user/ImportedTherapistsApi.binding.js';
export { hasAnyPermission, permissionsOptions, } from './user/Permission.js';
export { postClientRequestValidate, searchTherapistRequestValidate, searchTherapistResponseValidate, } from './user/UserApi.binding.js';
export { coverageTypes, genderToSalutation, genderType, invoiceDigitalType, locationType, pricing, publicVisibilityType, Roles, salutation, searchTherapistSortType, treatmentMethodType, userClientOpenApiFields, userCommonOpenApiFields, userInsuranceType, userJobTitleType, userSpecialistOpenApiFields, } from './user/UserApi.js';
export { searchTherapistSearchParamsValidateCoercing, } from './user/UserApiCoercing.binding.js';
export { nonEmptyEmail, nonEmptyString, nonNullableBoolean, nullableBoolean, nullableDecimalAsString, nullableEnum, nullableNonEmptyEmail, nullableNonEmptyString, nullableNumber, pagedSchemaOld, } from './validator.js';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Api({ baseUrl }) {
    return {
        auth: {
            login: {
                validateRequest: loginRequestValidate,
                request: apiCall('POST', `${baseUrl}/api/auth/login`),
            },
        },
        common: {
            version: {
                request: partialBind(version, baseUrl),
            },
            config: {
                request: apiCall('POST', `${baseUrl}/api/common/config`),
            },
            error: {
                url: `${baseUrl}/api/common/client-errors`,
            },
        },
        client: {
            therapist: {
                search: {
                    request: partialBind(searchTherapist, baseUrl),
                },
            },
            appointment: {
                book: {
                    validateRequest: appointmentBookRequestValidate,
                    request: partialBind(appointmentBook, baseUrl),
                },
                bookable: {
                    request: partialBind(searchBookableAppointments, baseUrl),
                },
            },
            invoice: {
                requestTan: {
                    request: partialBind(clientInvoiceDownloadRequestTan, baseUrl),
                },
                download: {
                    request: partialBind(clientInvoiceDownloadInvoice, baseUrl),
                },
            },
        },
        customer: {
            map: {
                url: (customerId) => `${baseUrl}/api/customer/${customerId}/map`,
            },
        },
        customerUser: {
            publicSearch: {
                request: apiCall('POST', `${baseUrl}/api/customer-user/public-search`),
            },
        },
        therapist: {
            imported: {
                search: {
                    request: partialBind(importedTherapistsSearch, baseUrl),
                },
                remove: {
                    request: partialBind(importedTherapistsDelete, baseUrl),
                },
            },
        },
    };
}
//# sourceMappingURL=index.js.map